import { useEffect, useRef } from "react";
import { useState } from "react";
import { Bar, Line } from "react-chartjs-2";
import api from "../../../services/api";
import { currencyMask } from "../../../utils/masks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleArrowDown } from "@fortawesome/free-solid-svg-icons";
import moment from '../../../utils/momentConfig';

const dataChart = {
  labels: [],
  options: {
    scales: {
      y: {
        beginAtZero: true
      }
    }
  },
  datasets: [
    {
      label: "Valores Pagos",
      data: [],
      borderColor: "rgb(99, 200, 255)",
      backgroundColor: "rgba(99, 221, 255, 0.5)",
      tension: 0.1,
      fill: true
    },
  ]
};

interface ChartDTO {
  month: number;
  year: number;
  totalPaid: number;
}

const CampaignChartPaidByMonth = () => {
  const [graphData, setGraphData] = useState<any>();
  const [hasError, setError] = useState<boolean>();
  const chartRef = useRef<any>(null);
  const title = "Valores Pagos por Mês";

  useEffect(() => {
    const init = async () => {
      try {
        const { data } = await api.get(`/campaigns/chart/paid-by-month`);

        if (!data.success) {
          setError(true);
          return;
        }

        if (!data.item || data.item.length == 0) {
          setError(true);
          return;
        }

        setGraphData(data.item);

        dataChart.labels = data.item.map((c: ChartDTO, index: number) => {
          let label = `${String(c.month).padStart(2, "0")}/${c.year}`;

          if (index > 0) {
            const prev = data.item[index - 1].totalPaid as number;
            if (prev == null) return label;
            if (prev === 0) {
              label += ' ▲ N/A';
            } else {
              const pct = ((c.totalPaid - prev) / prev * 100).toFixed(1);
              const arrow = +pct >= 0 ? '▲' : '▼';
              const sign = +pct >= 0 ? '+' : '';
              label += ` ${arrow} ${sign}${pct}%`;
            }
          }

          return label;
        });

        dataChart.datasets[0].data = data.item.map((c: ChartDTO) => {
          return c.totalPaid;
        });
      } catch (ex) {
        setGraphData(null);
        setError(true);
      }
    };
    init();
  }, []);


  const handleExport = () => {
    if (!chartRef.current) return;

    const chart = chartRef.current; 
    const url = chart.toBase64Image();
    
    const a = document.createElement('a');
    a.href = url;
    a.download = `${title.replace(/\s+/g, '-')}-${moment().valueOf()}.png`;
    a.click();
  };

  return (
    <div className="uk-grid-small" uk-grid="true">
      <div className="uk-width-1@s">
        <h3 className="uk-text-center uk-text-bold">
          {title}
          {
            !hasError && dataChart.labels.length > 0 &&
              <FontAwesomeIcon icon={faCircleArrowDown}
                className='uk-text-primary uk-margin-small-left cursor-pointer'
                onClick={handleExport}
                uk-tooltip="title: Exportar Imagem do Gráfico; pos: top"
                size='sm' />
          }
        </h3>
      </div>      
      <div className="uk-width-1@m uk-flex uk-flex-center">
        {hasError && hasError === true ? (
          <span className="uk-label uk-label-danger uk-text-center uk-margin-small-left">
            Gráfico não disponível
          </span>
        ) : !graphData ? (
          <div className="uk-text-center" uk-spinner="true; ratio:2">
            Carregando...
          </div>
        ) : (
          <Line
            data={dataChart}
            options={{
              scales: {
                y: {
                  beginAtZero: true,
                  ticks: {
                    callback: (value) => currencyMask(+value)
                  }
                }
              }
            }}
            ref={chartRef}
          />
        )}
      </div>
    </div>
  );
};

export default CampaignChartPaidByMonth;
